var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PaymentList',{attrs:{"payments":_vm.payments,"length":_vm.limit,"step":_vm.limit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }